import { Injectable } from '@angular/core';
import { ReadonlyRepositoryImpl, ApiService } from '@eceos/arch';
import { StreetType } from './streetType';

@Injectable({providedIn:'root'})
export class StreetTypesRepository extends ReadonlyRepositoryImpl<StreetType, StreetType> {
  constructor(api: ApiService) {
    super(api.root.path('streetTypes'), StreetType, StreetType);
  }
}
